export default "__VITE_ASSET__BTh6SbwP__"